<template>
    <div class="trim mb-3 d-md-flex" :class="{ active }" @click="select">
        <div
            class="top d-flex justify-content-between order-sm-2 flex-sm-grow-1"
        >
            <div class="name">
                <div class="year-make">
                    {{ trim.year }} {{ trim.make }} {{ trim.model }}
                </div>
                <div class="model-trim">{{ trim.trim }} {{ trim.name }}</div>
            </div>
            <div class="starting-at">
                <small>starting at</small>
                <div class="price">
                    {{ trim.startingAt | numeral("$0,0") }}
                </div>
            </div>
        </div>
        <div class="vehicle-image text-center order-sm-1 mr-sm-3">
            <trim-image :trim="trim" transparent />
        </div>
        <div class="bottom text-center d-md-none">
            <div class="engine-transmission">
                {{ trim.engineDisplacement }} {{ trim.transmissionDescription }}
            </div>
            <div class="more-wrapper">
                <b-link
                    v-if="!detailsOpen"
                    class="d-flex flex-column"
                    @click="detailsOpen = true"
                >
                    <i aria-hidden="true" class="ion-chevron-down" />
                    <span>more</span>
                </b-link>
                <b-collapse
                    id="details"
                    v-model="detailsOpen"
                    class="more-details m-3"
                >
                    <p v-if="baseTrim">
                        Includes select features of {{ baseTrim.trim }} model
                        plus...
                    </p>
                    <p v-else>
                        Includes the following standard features...
                    </p>
                    <div class="standards">
                        <ul>
                            <li
                                v-for="(standard, key) in standardDiff"
                                :key="key"
                            >
                                {{ standard.value }}
                            </li>
                        </ul>
                        <div>
                            <b-link @click="() => viewAllOptions(trim.id)">
                                View All
                            </b-link>
                        </div>
                    </div>
                    <b-link
                        class="d-flex flex-column"
                        @click="detailsOpen = false"
                    >
                        <i aria-hidden="true" class="ion-chevron-up" />
                        <span>view less</span>
                    </b-link>
                </b-collapse>
            </div>
            <action-buttons :trim="trim" />
        </div>
    </div>
</template>

<style lang="scss">
.trim {
    font-size: 12px;
    background-color: $very-light-gray;
    padding: 10px;

    .name {
        .year-make {
            font-size: 10px;
        }

        .model-trim {
            font-size: 16px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            max-width: 216px;
            text-overflow: ellipsis;
        }
    }

    .more-details {
        p {
            font-family: $helvetica-55-Roman;
            text-align: left;
        }

        li {
            text-align: left;
        }

        .standards {
            max-height: 190px;
            overflow-x: auto;

            a {
                font-size: 12px;
                font-style: normal;
            }
        }
    }

    .starting-at {
        small {
            font-size: 10px;
        }
        .price {
            color: $primary-blue;
            font-size: 28px;
            line-height: 34px;
        }
    }

    .more-wrapper {
        a {
            font-family: $helvetica-56-italic;
            font-style: italic;
            font-size: 10px;

            i {
                font-size: 12px;
                max-height: 12px;
            }
        }
    }

    @include media-breakpoint-up(md) {
        cursor: pointer;

        &:hover,
        &.active {
            box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.35);
        }

        &.active {
            .name {
                color: $primary-blue;
            }

            .starting-at {
                .price {
                    color: $primary-blue;
                }
            }
        }

        .vehicle-image {
            margin: -10px 0;
            min-width: 100px;

            img {
                max-width: 100px;
            }

            i {
                font-size: 2rem;
                padding: 20px 0;
            }
        }

        .name {
            .year-make {
                font-size: 14px;
                font-family: $helvetica-55-Roman;
            }

            .model-trim {
                font-size: 12px;
            }
        }

        .starting-at {
            .price {
                color: $dark-gray;
            }
        }
    }
}
</style>

<script>
import _ from "lodash";
import TrimImage from "../components/TrimImage";
import ActionButtons from "./ActionButtons";
import FeaturedOptionsMixin from "../mixins/FeaturedOptionsMixin";

export default {
    components: { ActionButtons, TrimImage },
    mixins: [FeaturedOptionsMixin],
    props: {
        trim: {
            type: Object,
            required: true
        },
        baseTrim: {
            type: Object,
            required: false,
            default: null
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            detailsOpen: false
        };
    },

    methods: {
        select() {
            this.$emit(
                "select",
                this.trim.id,
                _.get(this.baseTrim, "id", null)
            );
        },

        viewListings() {
            document.location = "/shop/new";
        },

        buildAndPrice() {
            document.location = `/configure/style/${this.trim.id}`;
        },

        compareSelected(checked) {
            this.$emit("compare", checked, this.trim);
        },

        viewAllOptions(trimId) {
            this.$emit(
                "select",
                this.trim.id,
                _.get(this.baseTrim, "id", null)
            );
            this.$emit("view-all-options");
        }
    }
};
</script>
